import styled, { css } from "styled-components";

export type StyledImagePresenterProps = {
  maxWidth?: React.CSSProperties["maxWidth"];
  maxHeight?: React.CSSProperties["maxHeight"];
  aspectRatio?: string;
};

export const StyledImagePresenter = styled.div<StyledImagePresenterProps>`
  width: fit-content;
  display: flex;
  justify-content: center;
  align-items: center;

  ${({ maxHeight }) =>
    maxHeight &&
    css`
      max-height: ${maxHeight};
    `};
  ${({ maxWidth }) =>
    maxWidth &&
    css`
      max-width: ${maxWidth};
    `};
  ${({ aspectRatio }) =>
    aspectRatio &&
    css`
      aspect-ratio: ${aspectRatio};
    `};
`;

export type StyledImgProps = {
  pointer?: boolean;
};

export const StyledImg = styled.img<StyledImgProps>`
  object-fit: contain;
  max-height: 100%;
  max-width: 100%;
  ${({ pointer }) =>
    pointer &&
    css`
      cursor: pointer;
    `};
`;
